import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DvirDto } from '@fleet-beat/api';
import {
  AuthHeaders,
  BaseApiService,
  CoreInjectorTokens,
  Environment,
  GetManyV2Dto,
  PageableListV2Dto,
  ResponseDto,
} from '@fleet-beat/core';
import { Observable, catchError, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DvirReportsApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/dvirs`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  getManyV2(data: GetManyV2Dto, auth: AuthHeaders): Observable<PageableListV2Dto<DvirDto>> {
    return this.baseApiService.get(this.baseUrl, { auth, params: data }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<DvirDto[]>) => this.baseApiService.mapResponseV2(response)),
      map((response: ResponseDto<DvirDto[]>) => {
        return {
          data: response.data,
          ...response.meta,
        };
      }),
    );
  }

  generatePDF(id: string, auth: AuthHeaders): Observable<ResponseDto<{ url: string }>> {
    return this.baseApiService.post(`${this.baseUrl}/${id}/generate-pdf`, {}, { auth }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<{ url: string }>) => this.baseApiService.mapResponseV2(response)),
    );
  }
}
